import React, { useState, useEffect } from 'react';
import NiceModal from "@ebay/nice-modal-react";
import { requester } from "App";
import { toast } from 'react-toastify';
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import ModalBase from "modals/base/ModalBase";
import styles from './StoreStockManagement.module.css';

const AddProductToStoreModal = NiceModal.create(props => {
    const [availableProducts, setAvailableProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        fetchAvailableProducts();
    }, []);

    const fetchAvailableProducts = async () => {
        try {
            const data = {
                storeCode: props.storeCode
            };
            await requester.findAvailableProductsToAdd(data, (result) => {
                setAvailableProducts(result.data);
                setIsLoading(false);
            });
        } catch (error) {
            console.error("Failed to fetch available products", error);
            setIsLoading(false);
        }
    };

    const handleAddProduct = async () => {
        if (!selectedProduct) return;

        try {
            const data = {
                storeCode: props.storeCode,
                id: selectedProduct.id
            };
            await requester.addProductToStore(data, (result) => {
                // code가 0이고 data가 존재할 때
                if (result.code === 0 && result.data) {
                    // 토스트 메시지 표시
                    toast.success(`${selectedProduct.productName} 상품이 성공적으로 추가되었습니다.`);
                    
                    // 부모 컴포넌트의 재고 갱신 함수 호출
                    props.onProductAdded && props.onProductAdded(result.data);
                    
                    // 상품 목록 다시 불러오기
                    fetchAvailableProducts();
                    
                    // 선택 초기화
                    setSelectedProduct(null);
                }
            });
        } catch (error) {
            console.error("Failed to add product", error);
            toast.error("상품 추가 중 오류가 발생했습니다.");
        }
    };

    return (
        <ModalBase
            slideUp
            width="80%"
            height="80%"
            withHeader={false}
            withFooter={false}
            withCloseButton={true}
            clickOutsideToClose={true}
            overflow="auto"
            borderRadius="25px"
            onClose={props.onClose}
            backgroundColor="var(--bg-color)"
        >
            <VerticalFlex
                backgroundColor="white"
                padding="max(1vw, 10px)"
                borderRadius="1rem"
            >
                <FlexChild alignItems="flex-start">
                    <P size="max(1.4vw, 10px)" padding="0 0 1rem" weight={700}>
                        새 상품 추가 - {props.storeName}
                    </P>
                </FlexChild>

                {isLoading ? (
                    <div className={styles.loading}>상품을 불러오는 중...</div>
                ) : availableProducts.length > 0 ? (
                    <div className={styles.lowStockList}>
                        {availableProducts.map(product => (
                            <div 
                                key={product.id} 
                                className={`
                                    ${styles.lowStockItem} 
                                    ${selectedProduct?.id === product.id ? styles.selectedProduct : ''}
                                `}
                                onClick={() => setSelectedProduct(product)}
                            >
                                <div className={styles.lowStockItemContent}>
                                    {product.productImg ? (
                                        <img 
                                            src={product.productImg} 
                                            alt={product.productName} 
                                            className={styles.lowStockProductImage} 
                                        />
                                    ) : (
                                        <div className={styles.lowStockNoImage}>이미지 없음</div>
                                    )}
                                    <div className={styles.productInfo}>
                                        <div className={styles.productName}>{product.productName}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={styles.noData}>
                        추가 가능한 상품이 없습니다.
                    </div>
                )}

                <HorizontalFlex justifyContent="flex-end" padding="1rem 0 0">
                    <button 
                        onClick={handleAddProduct} 
                        disabled={!selectedProduct}
                        className={styles.confirmButton}
                    >
                        상품 추가
                    </button>
                </HorizontalFlex>
            </VerticalFlex>
        </ModalBase>
    );
});

export default AddProductToStoreModal;